/**
 * A helper class for parsing GeoJSON data.
 */
class GJ {
    constructor(json) {
        this.json = json;
    }
    getFeatures() {
        var _a;
        return (_a = this.json["features"]) !== null && _a !== void 0 ? _a : [];
    }
    /**
     * Return segments from all features
     */
    getAllSegments() {
        const collectedSegments = [];
        this.getFeatures().forEach((feature) => {
            var _a;
            if (feature.properties && feature.properties.segments) {
                collectedSegments.push(...((_a = feature.properties.segments) !== null && _a !== void 0 ? _a : []));
            }
        });
        return collectedSegments;
    }
    // Return all steps from all segments
    getAllSteps() {
        const collectedSteps = [];
        this.getAllSegments().forEach(segment => {
            var _a;
            collectedSteps.push(...((_a = segment.steps) !== null && _a !== void 0 ? _a : []));
        });
        return collectedSteps;
    }
}
export default GJ;
